import { ReactNode, memo } from "react";
import { MiIcon } from "@miplatform/components";
import { mdiCalendarBlankOutline } from "@mdi/js";
import { Box, Typography, useTheme } from "@mui/material";

interface AssignmentsStackedFieldProps {
  icon?: string;
  title?: string;
  children?: ReactNode;
}

export const AssignmentsStackedField = memo(
  ({
    icon = mdiCalendarBlankOutline,
    title,
    children,
  }: AssignmentsStackedFieldProps) => {
    const theme = useTheme();

    return (
      <Box
        display="flex"
        alignItems="flex-start"
        flexDirection="column"
        gap={0.75}
      >
        <Box display="flex" alignItems="center" gap={1} mt={0.25}>
          <MiIcon path={icon} size={0.5} color={theme.palette.grey[600]} />
          <Typography fontSize={13} color="text.secondary" lineHeight={1.2}>
            {title}
          </Typography>
        </Box>
        <Typography
          fontSize={14}
          fontWeight={700}
          color={theme.palette.primary.main}
          lineHeight={1.3}
        >
          {children}
        </Typography>
      </Box>
    );
  }
);
